/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React from 'react';
// import styles from "./Cta.module.css";
import styles from '../../styles/components/controlVariations/Cta.module.css';

type Variant = 'primary' | 'secondary';
type State = 'default' | 'hover' | 'inactive' | 'hazard';

interface ButtonProps {
	variant: Variant;
	state?: State;
	children: React.ReactNode;
	onClick?: () => void;
}

export const Cta: React.FC<ButtonProps> = ({
	variant,
	state = 'default',
	children,
	onClick,
}) => {
	// Build className like ctaPrimaryDefault / ctaSecondaryHazard
	const className = `${styles.ctaButton} ${styles[`cta${capitalize(variant)}${capitalize(state)}`]}`;

	return (
		<button
			className={className}
			onClick={onClick}
			disabled={state === 'inactive'}
		>
			{children}
		</button>
	);
};

// Helper to capitalize state & variant
function capitalize(str: string) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}
